import { Box, Typography } from '@mui/material';
import PnLChart from 'components/optionsCalculator/PnLChart';
import PositionContainer from 'components/optionsCalculator/positionManagement/PositionContainer';
import TickerOverview from 'components/optionsCalculator/TickerOverview';
import { COMBINED_SIGNALS } from 'config';
import { useOptionsCalculatorActions } from 'hooks/optionsCalculator/useOptionsCalculatorActions';
import { VerticalDashboardLayout } from 'layouts/VerticalDashboardLayout';
import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
  searchSuggestionsData,
  searchHandlerState,
  hiroSymbolsState,
  unpricedEquitiesState,
} from 'states';
import { EquityFieldKey } from 'types';
import {
  ProductType,
  SearchHandlerFunction,
  SuggestionSearchData,
} from 'types/shared';

const PlaceholderBox = ({ title }: { title: string }) => (
  <Box
    sx={{
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Typography variant="h6" color="text.secondary">
      {title} Placeholder
    </Typography>
  </Box>
);

const OptionsCalculatorContainer = () => {
  const hiroSyms = useRecoilValue(hiroSymbolsState);
  const unpricedEquities = useRecoilValue(unpricedEquitiesState);
  const { handleSymChange } = useOptionsCalculatorActions();

  const setSuggestionsData = useSetRecoilState(searchSuggestionsData);
  const setSuggestionsHandler = useSetRecoilState(searchHandlerState);

  useEffect(() => {
    const suggestionsHandler: SearchHandlerFunction = (val: string): void => {
      if (val != null && val != '') {
        handleSymChange(val);
      }
    };
    setSuggestionsHandler(() => suggestionsHandler);
  }, [setSuggestionsHandler, handleSymChange]);

  useEffect(() => {
    const result: SuggestionSearchData[] = Array.from(hiroSyms.values()).map(
      (data: string) => ({
        symbol: data,
        name: unpricedEquities.get(data)?.[EquityFieldKey.name] || data,
      }),
    );

    const suggestions = result.filter(
      (value: { symbol: string; name: string }) =>
        !COMBINED_SIGNALS.has(value.symbol) && value.symbol !== 'Mag7',
    );
    setSuggestionsData(suggestions);
  }, [setSuggestionsData, hiroSyms, unpricedEquities]);

  return (
    <VerticalDashboardLayout
      dashboardId={ProductType.OPTIONS_CALCULATOR}
      mainContent={<PnLChart />}
      topLeftContent={<TickerOverview />}
      topRightContent={<PlaceholderBox title="Top Right" />}
      bottomContent={<PositionContainer />}
      mainContentHeaderName="P&L Chart"
      bottomContentHeaderName="Manage Position"
    />
  );
};

export default OptionsCalculatorContainer;
